const baseEvent = {
  event: 'loadEventData',
  eventCategory: 'Ask Me Anything',
  nonInteractive: false,
  customMetrics: {},
  customVariables: {},
  _clear: true
}

export default {
  onInitialize: (eventLabel: string, buttonLocation: string) => ({
    ...baseEvent,
    eventAction: 'Initiation Click',
    eventLabel,
    customVariables: {
      buttonLocation,
      vendor: 'Clarity AI'
    }
  }),
  onAction: (eventAction: string, eventLabel?: string, buttonLocation?: string) => ({
    ...baseEvent,
    eventAction,
    eventLabel,
    customVariables: {
      ...(buttonLocation ? { buttonLocation } : {}),
    }
  })
}
